import React from 'react';

import { useAtomValue } from 'jotai';

import { BulkPublishModeProvider } from '../../../contexts/BulkPublishModeContext.jsx';
import { useSuggestionFilter } from '../../../hooks/useSuggestionFilter.js';
import { useInfiniteSuggestionQuery } from '../../../queries/suggestions.js';
import { selectedSuggestionAtom } from '../../../store/suggestion/selectedSuggestion.js';
import SuggestionPanel from '../../molecules/SuggestionPanel/SuggestionPanel.jsx';
import TabLayout from '../../molecules/TabLayout/TabLayout.jsx';
import SuggestionEntity from '../SuggestionEntity/SuggestionEntity.jsx';
import SuggestionEntityEmpty from '../SuggestionEntity/SuggestionEntityEmpty.jsx';

type Props = {
  bulkPublishEnabled?: boolean;
};

const SuggestionTab = ({ bulkPublishEnabled = false }: Props) => {
  const selectedSuggestion = useAtomValue(selectedSuggestionAtom);
  const { selectedSuggestionFilter, isFilterLoading } = useSuggestionFilter();

  const { data, isLoading } = useInfiniteSuggestionQuery({
    ...selectedSuggestionFilter,
  });

  const tabSuggestions = data?.pages.flatMap((p) => p.items);

  //complex key is present here as prop in order to reset component state
  return (
    <BulkPublishModeProvider enabled={bulkPublishEnabled}>
      <TabLayout
        isBulkPublish={bulkPublishEnabled}
        cardList={<SuggestionPanel />}
        mainContent={
          selectedSuggestion ? (
            <SuggestionEntity
              key={`${selectedSuggestion?.id}-${selectedSuggestion?.status}`}
              suggestion={selectedSuggestion}
            />
          ) : (
            <SuggestionEntityEmpty
              isTabEmpty={!tabSuggestions?.length}
              isProgress={isLoading || isFilterLoading}
            />
          )
        }
      />
    </BulkPublishModeProvider>
  );
};

export default SuggestionTab;
